// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"f53f41c5","194":"2551f9cd","232":"2def038f","272":"ba2a5811","449":"6f2cf761","519":"add76f0b","553":"39404677","773":"a1053bb5","779":"74fdec7b","851":"1b7ea469"}[chunkId] + ".chunk.js";
};